import {
    Truck,
    Star,
    XCircle,
    IndianRupee,
    CalendarDays,
    Wallet,
} from "lucide-react";

import "./DeliveryStatsCard.css";

function DeliveryStatsCard({ statistics }) {

    return (

        <div className="delivery-stats-card">

            <div className="card-title">

                <h3>Delivery Statistics</h3>

            </div>

            <div className="stats-grid">

                <div className="stat-box">

                    <Truck size={22} />

                    <div>

                        <span>Total Deliveries</span>

                        <h4>{statistics?.totalDeliveries || 0}</h4>

                    </div>

                </div>

                <div className="stat-box">

                    <Star size={22} />

                    <div>

                        <span>Rating</span>

                        <h4>{statistics?.rating || 0}</h4>

                    </div>

                </div>

                <div className="stat-box">

                    <XCircle size={22} />

                    <div>

                        <span>Cancelled</span>

                        <h4>{statistics?.cancelled || 0}</h4>

                    </div>

                </div>

                <div className="stat-box">

                    <IndianRupee size={22} />

                    <div>

                        <span>Today's Earnings</span>

                        <h4>₹ {statistics?.todayEarnings || 0}</h4>

                    </div>

                </div>

                <div className="stat-box">

                    <CalendarDays size={22} />

                    <div>

                        <span>This Month</span>

                        <h4>₹ {statistics?.monthEarnings || 0}</h4>

                    </div>

                </div>

                <div className="stat-box">

                    <Wallet size={22} />

                    <div>

                        <span>Total Earnings</span>

                        <h4>₹ {statistics?.totalEarnings || 0}</h4>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default DeliveryStatsCard;